/**
 * abilityVfxTibbersSummon — Annie R Summon: Tibbers ground flame burst (SP-16).
 * Unit Tibbers deferred; this is the cast AoE burst only.
 */
export function buildTibbersSummon(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.55 * (spec.scale || 2.4);
  const crimson = mat(THREE, spec.color || 0xb91c1c, 0.78);
  const orange = mat(THREE, 0xea580c, 0.88);
  const gold = mat(THREE, 0xfbbf24, 0.92);
  addAoeRings(THREE, group, s, crimson, orange, gold);
  addCentralBurst(THREE, group, s, orange, gold);
  addFlamePillars(THREE, group, s, crimson, orange);
  addEmbers(THREE, group, s, gold);
  group.userData = { shape: 'tibbers_summon' };
  return group;
}

function addAoeRings(THREE, group, s, crimson, orange, gold) {
  const outer = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.75, s * 1.15, 28).rotateX(-Math.PI / 2),
    crimson
  );
  outer.position.y = 0.04;
  group.add(outer);
  const mid = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.4, s * 0.72, 24).rotateX(-Math.PI / 2),
    orange
  );
  mid.position.y = 0.05;
  group.add(mid);
  const core = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.12, s * 0.38, 20).rotateX(-Math.PI / 2),
    gold
  );
  core.position.y = 0.06;
  group.add(core);
}

function addCentralBurst(THREE, group, s, orange, gold) {
  const flash = new THREE.Mesh(new THREE.SphereGeometry(0.32 * s, 12, 12), gold);
  flash.position.y = 0.35 * s;
  group.add(flash);
  const column = new THREE.Mesh(
    new THREE.CylinderGeometry(0.12 * s, 0.28 * s, 0.9 * s, 10),
    orange
  );
  column.position.y = 0.55 * s;
  group.add(column);
}

function addFlamePillars(THREE, group, s, crimson, orange) {
  for (let i = 0; i < 6; i += 1) {
    const a = (Math.PI * 2 / 6) * i;
    const r = s * 0.7;
    const pillar = new THREE.Mesh(
      new THREE.ConeGeometry(0.14 * s, 0.7 * s, 5),
      i % 2 === 0 ? orange : crimson
    );
    pillar.position.set(Math.cos(a) * r, 0.4 * s, Math.sin(a) * r);
    group.add(pillar);
  }
}

function addEmbers(THREE, group, s, gold) {
  for (let i = 0; i < 5; i += 1) {
    const a = (Math.PI * 2 / 5) * i + 0.3;
    const ember = new THREE.Mesh(new THREE.SphereGeometry(0.08 * s, 8, 8), gold);
    ember.position.set(Math.cos(a) * s * 0.95, 0.25 * s, Math.sin(a) * s * 0.95);
    group.add(ember);
  }
}

function mat(THREE, color, opacity) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side: THREE.DoubleSide
  });
}
